export {
    addFocus,
    syntheticFocus,
    applyBlur,
    applyDisabled,
    applyEllipsis,
    applyHyphens,
    applyMaxLines,
    applyNoSelect,
    applyRoundness,
    radiuses,
    applyView,
    views,
    applyScrollSnap,
    applySkeletonGradient,
    applySpacing,
} from '@sberdevices/plasma-core';
export type {
    BreakWordProps,
    FocusProps,
    OutlinedProps,
    BlurProps,
    DisabledProps,
    MaxLinesProps,
    RoundnessProps,
    Roundness,
    SkeletonGradientProps,
    SpacingProps,
    ViewProps,
    View,
} from '@sberdevices/plasma-core';

export { applyInteraction } from './applyInteraction';
export type { InteractionProps } from './applyInteraction';
